@import '~style-sheet-helpers/core.less';
@import '../../../../app-brand/entities/entity-layer.module.less';

.order-summary {
  display: grid;
  gap: 15px;
  margin-top: 15px;
}

.input-wrapper {
  font-size: 14px;

  .store-label {
    margin-bottom: 5px;
    margin-right: 15px;
  }

  .input-label {
    display: block;
    margin-bottom: 5px;
    white-space: nowrap;
  }

  .date-picker-input {
    height: 32px;
    background: inherit;
    width: 100%;
    input {
      width: calc(100% - 30px);
    }
  }

  .currency-input {
    height: 32px;

    div[class^='currency'] {
      z-index: 1;
    }
  }
}

.store-dropdown-toggler {
  border: 1px solid @new-order-modal--order-summary--border-color;
  border-radius: 5px;
  height: 32px;
  background-color: @new-order-modal--order-summary--background-color;
}

.order-summary-input {
  background: inherit;

  input[class^='flex-input'] {
    background: @new-order-modal--order-summary--background-color;
  }
}

.checkbox-row {
  padding-top: 5px;
}
